function validatePostalCode(postalCode = null) {
    if(!postalCode){
        return true;
    }
    else{
        var pattern = /^\d{2}-\d{3}$/;
        return pattern.test(postalCode); // zwraca true, jeśli kod pocztowy jest poprawny, lub false w przeciwnym przypadku
    }
}
var postalCodeInput = document.getElementById("acf-field_612bdc24eba44-field_612bdc57eba46"); // pobiera element input z kodem pocztowym
var submitButton = document.getElementById("saveclient"); // pobiera przycisk do przesłania formularza
if($('#saveclient').length > 0) {
    submitButton.addEventListener("click", function (event) {
        var postalCode = postalCodeInput.value; // pobiera wartość kodu pocztowego z inputu
        if (!validatePostalCode(postalCode)) { // jeśli kod pocztowy jest niepoprawny, blokuje przesłanie formularza i wyświetla komunikat o błędzie
            event.preventDefault(); // blokuje przesłanie formularza
            setTimeout(function(){
                $('#acf-field_612bdc24eba44-field_612bdc57eba46').closest('.acf-input .acf-notice').remove();
                $('#acf-field_612bdc24eba44-field_612bdc57eba46').closest('.acf-input').prepend('<div class="acf-notice -error acf-error-message"><p>Niepoprawny kod pocztowy</p></div>');
            }, 1000)
            // alert("Niepoprawny kod pocztowy!"); // wyświetla komunikat o błędzie
        }
    });
}